import React, { useCallback, useEffect, useRef } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, DialogActions, DialogContent } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { FormikButton, FormikGrid, FormikTextField } from '@sierralabs/react-material-ui-formik';
import { useCreateFolder } from '../hooks/useCreateFolder';
const FolderUploadInput = props => {
    const { content, actions, folderName, parentFolder, createOnMount = false, onLoad, onError, onSelect } = props;
    const formikRef = useRef(null);
    const { data, isLoading, error, createFolder } = useCreateFolder();
    const isParentRoot = parentFolder.id === null;
    const parentId = parentFolder.id;
    const doCreateFolder = useCallback((folderName) => createFolder({ name: folderName, parentId }), [parentId, createFolder]);
    useEffect(() => {
        var _a;
        (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.setSubmitting(isLoading);
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);
    useEffect(() => {
        // attempt to create folder if name is available
        if (folderName && createOnMount) {
            doCreateFolder(folderName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [folderName, doCreateFolder]);
    useEffect(() => {
        if (data) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(data, true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    useEffect(() => {
        if (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
    return (React.createElement(Formik, { innerRef: formikRef, initialValues: { name: folderName || '' }, validationSchema: Yup.object({
            name: Yup.string().required('Folder name is required.')
        }), onSubmit: ({ name }) => doCreateFolder(name) },
        React.createElement(Form, { autoComplete: 'off' },
            React.createElement(DialogContent, { style: { paddingTop: 8 } },
                React.createElement(FormikGrid, null,
                    React.createElement(FormikTextField, { autoFocus: true, type: 'text', name: 'name', label: 'Folder Name', disabled: isLoading })),
                React.createElement(Alert, { severity: 'info' },
                    !folderName && 'No folder name detected.',
                    " Upload files to the",
                    ' ',
                    isParentRoot ? (React.createElement(React.Fragment, null,
                        React.createElement("strong", null, "root"),
                        " folder")) : (React.createElement(React.Fragment, null,
                        "current folder ",
                        React.createElement("strong", null, parentFolder.name || '?'))),
                    ' ',
                    "or specify the name of the new folder to create.")),
            content,
            React.createElement(DialogActions, null,
                actions,
                React.createElement(Button, { color: 'primary', variant: 'outlined', disabled: isLoading, onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(parentFolder, false) },
                    "Upload to ",
                    isParentRoot ? 'root' : 'current',
                    " Folder"),
                React.createElement(FormikButton, null, "Create Folder")))));
};
export default FolderUploadInput;
//# sourceMappingURL=FolderUploadInput.js.map